import { render, staticRenderFns } from "./LabelsBackup.vue?vue&type=template&id=66f33a64&"
import script from "./LabelsBackup.vue?vue&type=script&lang=js&"
export * from "./LabelsBackup.vue?vue&type=script&lang=js&"
import style0 from "./LabelsBackup.vue?vue&type=style&index=0&id=66f33a64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports